import $ from 'jquery';
import React from 'react';
import { userService } from '../../_services';
import Resolved from '../../components/css/dark/img/true-icon.png';
import Rxresolved from '../../components/css/dark/img/rx-true-icon.png';
import Pagination from "react-js-pagination";
import Linkify from 'react-linkify';

class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            disabled: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            notification: [],
            notification_Temp: [],
            activePage: 1,
            currentPaging: 1,
            error: ''
        };
    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        this.fetchDataLocally(this.state.userdata.userrole, this.state.userdata.email, '');
    }
    fetchDataLocally(UserType, UserEmail, FilterJson, cPage) {
        try {
            userService.GetNotification(UserType, UserEmail, FilterJson).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata.length <= 9)
                                this.setState({ notification: apidata, notification_Temp: apidata, loader: false, error: '' });
                            else {
                                let userlistobj = JSON.parse(JSON.stringify(apidata));
                                let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
                                this.setState({ notification: apidata, notification_Temp: usertemplistobj, loader: false, error: '' });
                            }
                            if (this.props.cPage > 1) {
                                this.terminatedPageChange(this.props.cPage);
                            }
                            if (cPage != undefined ) {
                                this.terminatedPageChange(cPage);
                            }
                        }
                        else {
                            this.setState({ error: 'No notification created so far', loader: false });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error', loader: false });
                    }
                });
        }
        catch (error) {
        }
    }
    createNotification = () => {
        try {
            this.props.closeNotification();
            this.props.openCreateNotification(this.state.activePage);
        } catch (error) {
            this.setState({ error: 'Error', loader: false });
        }
    }
    terminatedPageChange = (pageNumber) => {
        try {
            let userlistobj = JSON.parse(JSON.stringify(this.state.notification));
            let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ activePage: pageNumber, notification_Temp: usertemplistobj, loader: false, currentPaging: pageNumber, error: '' });
            $("a[aria-label='Go to page number " + this.state.currentPaging + "']").parents("li").addClass('active');
        } catch (error) {
            this.setState({ error: 'Error', loader: false });
        }
    }
    convertUTCDateToLocalDate = (serverdate) => {
        var dateLocal = new Date(serverdate);
        return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(dateLocal.getTime() - dateLocal.getTimezoneOffset() * 60 * 1000));
    }
    handleFlip = (event) => {
        $(event.target).children('.hide-loader').css("display", "block");
        this.makeNotificationResolved(event.target.id, this.state.userdata.userrole, this.state.userdata.email, '', this.state.currentPaging);
    }
    makeNotificationResolved(Not_Id, UserType, UserEmail, FilterJson, cPage) {
        try {
            userService.NotificationClosing(Not_Id, UserType, UserEmail, FilterJson).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].statuscode == 1) {
                                this.setState({ error: apidata[0].statusmessage });
                                $('.hide-loader').css("display", "none");
                                setTimeout(() => {
                                    this.setState({ error: '' });
                                }, 5000);
                                this.fetchDataLocally(this.state.userdata.userrole, this.state.userdata.email, '', cPage);
                            } else {
                                this.setState({ error: apidata[0].statusmessage });
                                $('.hide-loader').css("display", "none");
                            }
                        }
                        else {
                            this.setState({ error: 'Error' });
                            $('.hide-loader').css("display", "none");
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error', notificationLoader: false });
                        $('.hide-loader').css("display", "none");
                    }
                });
        }
        catch (error) {
            this.setState({ error: 'Error' });
            $('.hide-loader').css("display", "none");
        }
    }
    render() {
        const { loader, disabled, notification, notification_Temp, activePage, error, notificationLoader } = this.state;
        const componentDecorator = (href, text, key) => (
            <a className="linkify__text" href={href} key={key} target="_blank">
                {text}
            </a>
        );
    return (
            <div>
                <div className='popup mfp-zoom-in manage-scroll manage-distributor-design admin-group-number notification'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closeNotification}>X</button></h1>
                        {
                            loader ? (<div className="theme-loader"></div>) : null
                        }
                        <button className="btn add-wholesaler" disabled={disabled} onClick={this.createNotification}>Create new</button>
                        <div className="notification-section">
                            {
                                notification != null && notification.length > 0 ?
                                    <table>
                                        <thead>
                                            <tr className="header">
                                                <th className="first-one">Date & Time</th>
                                                <th className="second-one">User</th>
                                                <th className="third-one">Content</th>
                                                <th className="fourth-one">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody id="inactive_reps">
                                            {
                                                notification_Temp.map((item, index) => {
                                                    return (
                                                        <tr className="userDashData" key={index}>
                                                            <td className="first-one">{this.convertUTCDateToLocalDate(item.publishedOn)}</td>
                                                            <td className="second-one">{item.userFor}</td>
                                                            <td className="third-one"><Linkify componentDecorator={componentDecorator}>{item.not_Content}</Linkify></td>
                                                            <td className="fourth-one">
                                                                {item.scheduleStatus == "Upcoming" ? null :
                                                                    <div>
                                                                        {
                                                                            item.isClosed ? null
                                                                                : <a id={item.not_Id} href="javascript:void('0')" onClick={this.handleFlip} className="flip">
                                                                                    <img id={item.not_Id} src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rxresolved : Resolved} alt="Upcoming" />
                                                                                    <div className="hide-loader"><div className="theme-loader"></div></div>
                                                                                    <a href="javascript:void('0')" className="custom-tooltip">
                                                                                        <span className="hover-tooltip">Mark Resolved</span>
                                                                                    </a>
                                                                                </a>
                                                                        }
                                                                    </div>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                )
                                            }
                                        </tbody>
                                    </table> : null
                            }
                            {
                                notification != null && notification.length > 0 ?
                                    <Pagination
                                        activePage={activePage}
                                        itemsCountPerPage={9}
                                        totalItemsCount={notification.length}
                                        pageRangeDisplayed={5}
                                        onChange={this.terminatedPageChange.bind(this)}
                                    /> : null
                            }
                            {error &&
                                <div className={'alert alert-danger delete'}>{error}</div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Notification;